export default function validateDomain(input: string): string | null {
	try {
		const withScheme = input.includes("://") ? input : `https://${input}`;
		const url = new URL(withScheme);

		const hostname = url.hostname;

		const isValid =
		/^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,63}$/i.test(hostname) &&
		!/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

		if (!isValid) return null;

		return hostname.toLowerCase();
	} catch {
		return null;
	}
}
